import React from 'react';
import { Block } from '@guryou/html-components';
import { dealTokens } from 'components/shared';

// `nested`: skip the lg/md column sizing when InfoContainer isn't a direct MainContainer child
// (e.g. wrapped in the step's own lg={5.6} Block alongside a sibling like CalendarDuration below
// it) — two 5.6-of-12 sizings compounding on top of each other shrinks the card to ~22% width,
// not the intended ~47%, since the size is a percentage of whatever parent it's actually in.
const InfoContainer = ({ children, nested = false }) => {
  return (
    <Block
      {...(nested ? {} : { lg: 5.6, md: 5.8 })}
      xs={12}
      margin={0}
      marginTop={4}
      padding={8}
      backgroundColor={dealTokens.color.surface}
      border={`1px solid ${dealTokens.color.border}`}
      borderRadius={`${dealTokens.radius.lg}px`}
      boxShadow={dealTokens.shadow.subtle}
    >
      {children}
    </Block>
  );
};

export default InfoContainer;
